<template>
  <div v-if="this.voucher">
    <div class="relative bg-white rounded-2xl shadow-md p-6 mx-auto">
      <div class="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-2">
        <StackedField label="Titre" :value="voucher.title" />
        <StackedField label="Description" :value="voucher.description" />
        <StackedField label="Code" :value="voucher.code" />
        <StackedField label="Reference ID" :value="voucher.referenceId" />
        <StackedField label="Date d'utilisation" :value="voucher.usageDate" />
        <StackedField label="Montant" :value="formatPrice(voucher.amount)" />
        <StackedField label="Utilisable jusqu'à" :value="voucher.endValidityDate" />
      </div>
    </div>
  </div>
</template>

<script>
import { StackedField, formatPrice } from "@estaly/ui";

export default {
  props: ["voucher"],
  components: {
    StackedField,
  },
  methods: {
    formatPrice,
  },
};
</script>
